import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import GrowthFeaturesData from '../../data/smm/GrowthFeatures.json';
import SectionTitle from '../../elements/section-title/SectionTitle';

const GrowthPrioritySection = () => {
    return (
        <div className="section section-padding bg-color-dark" style={{ position: 'relative', overflow: 'hidden' }}>
            <div className="container">
                <SectionTitle
                    subtitle="Why Choose Us"
                    title="Your Growth, Our Priority"
                    textAlignment="heading-center heading-light"
                    textColor=""
                    paragraphClass="d-none"
                />

                <div className="d-flex flex-column flex-md-row gap-5 gap-md-2">
                    {/* Left Column - 2 features */}
                    <div className="mb-4 mb-lg-0 d-flex align-items-center">
                        <div className="d-flex flex-column" style={{
                            gap: "60px"
                        }}>
                            {GrowthFeaturesData.slice(0, 2).map((feature, index) => (
                                <AnimationOnScroll
                                    key={index}
                                    animateIn="fadeInLeft"
                                    animateOnce={true}
                                    delay={index * 100}
                                >
                                    <div className="growth-feature-card">
                                        <div className="icon-wrapper">
                                            <img
                                                src={process.env.PUBLIC_URL + feature.image}
                                                alt={feature.title}
                                                className="feature-icon"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                        <div className="feature-content">
                                            <h5 className="feature-title">{feature.title}</h5>
                                            <p className="feature-description">
                                                {feature.description}
                                            </p>
                                        </div>
                                    </div>
                                </AnimationOnScroll>
                            ))}
                        </div>
                    </div>

                    {/* Center Column - Illustration */}
                    <div className="d-flex align-items-center justify-content-center">
                        <AnimationOnScroll
                            animateIn="zoomIn"
                            animateOnce={true}
                            delay={200}
                        >
                            <div className="growth-illustration text-center">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/icon/SMM-seatingman.png"}
                                    alt="Growth Metrics"
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    onError={(e) => {
                                        e.target.src = process.env.PUBLIC_URL + "/images/banner/SMM-hero.png";
                                    }}
                                />
                            </div>
                        </AnimationOnScroll>
                    </div>

                    {/* Right Column - 2 features */}
                    <div className="d-flex align-items-center">
                        <div className="d-flex flex-column" style={{
                            gap: "60px"
                        }}>
                            {GrowthFeaturesData.slice(2, 4).map((feature, index) => (
                                <AnimationOnScroll
                                    key={index + 2}
                                    animateIn="fadeInRight"
                                    animateOnce={true}
                                    delay={index * 100}
                                >
                                    <div className="growth-feature-card">
                                        <div className="icon-wrapper">
                                            <img
                                                src={process.env.PUBLIC_URL + feature.image}
                                                alt={feature.title}
                                                className="feature-icon"
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                        <div className="feature-content">
                                            <h5 className="feature-title">{feature.title}</h5>
                                            <p className="feature-description">
                                                {feature.description}
                                            </p>
                                        </div>
                                    </div>
                                </AnimationOnScroll>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative background elements */}
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-9.png"} alt="Circle" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-42.png"} alt="Circle" />
                </li>
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-43.png"} alt="Circle" />
                </li>
            </ul>

            <style jsx>{`
                .growth-feature-card {
                    display: flex;
                    align-items: flex-start;
                    gap: 20px;
                    background-color: transparent;
                    padding: 0;
                    border-radius: 0;
                    backdrop-filter: none;
                    border: none;
                    transition: all 0.3s ease;
                    cursor: pointer;
                }

                .growth-feature-card:hover {
                    transform: translateY(-5px);
                }

                .growth-feature-card:hover .icon-wrapper {
                    transform: scale(1.05);
                }

                .icon-wrapper {
                    flex-shrink: 0;
                    width: 80px;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: transparent;
                    border-radius: 0;
                    padding: 0;
                    transition: transform 0.3s ease;
                }

                .feature-icon {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    filter: none;
                }

                .feature-content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    padding-top: 0;
                }

                .feature-title {
                    color: #ffffff;
                    font-size: 19px;
                    font-weight: 700;
                    line-height: 1.3;
                    margin: 0;
                    letter-spacing: -0.5px;
                }

                .feature-description {
                    color: rgba(255, 255, 255, 0.75);
                    font-size: 14px;
                    line-height: 1.65;
                    margin: 0;
                    font-weight: 400;
                }

                @media (max-width: 991px) {
                    .icon-wrapper {
                        width: 70px;
                        height: 70px;
                    }

                    .feature-title {
                        font-size: 19px;
                    }

                    .feature-description {
                        font-size: 14px;
                    }
                }

                @media (max-width: 767px) {
                    .growth-feature-card {
                        gap: 15px;
                    }

                    .icon-wrapper {
                        width: 60px;
                        height: 60px;
                    }

                    .feature-title {
                        font-size: 18px;
                    }

                    .feature-description {
                        font-size: 14px;
                    }
                }
            `}</style>
        </div>
    );
};

export default GrowthPrioritySection;